export const DEFAULT_BACK_STATE = {
    visible: false,
};
